import { SupervisorTableHeaderProps } from "./types";
import { Text, mergeClasses } from "@fluentui/react-components";
import { TableType } from "@/common/types";
import { useCallback } from "react";
import { useIntl } from "react-intl";
import { useInteractionStyle } from "@/components/organisms/interaction/style";
import { Flex, GapSize } from "@/components/atoms/flex";
import { CacheKey } from "@/common/stores/persistingStores/app";
import { SupervisorQueueFilter } from "@/components/molecules/queueFilter/SupervisorQueueFilter";
import { SupervisorTypeFilter } from "@/components/molecules/typeFilter/SupervisorTypeFilter";

export const SupervisorTableHeader = (props: SupervisorTableHeaderProps) => {
	const { type, label, style, className, filterData } = props;
	const intl = useIntl();
	const classes = useInteractionStyle();

	const getCacheKeyByTableType = useCallback(() => {
		switch (type) {
			case TableType.Active:
				return CacheKey.ActiveListFilterData;
			case TableType.None:
				return CacheKey.WaitingListFilterData;
			default:
				return "";
		}
	}, []);

	return (
		<Flex
			className={
				type === TableType.Active || type === TableType.None
					? mergeClasses(
							classes.activeHeaderContainer,
							className?.activeContainer
						)
					: classes.waitingHeaderContainer
			}
			hAlign="space-between"
			style={style?.activeContainer}
		>
			<Flex vAlign="center" style={{ flexShrink: 0 }}>
				<Text
					className={
						type === TableType.Active || type === TableType.None
							? classes.activeHeader
							: classes.waitingHeader
					}
				>
					{label ??
						intl.formatMessage({
							id: `Interaction.Contents.${TableType[type]}Interactions`,
						})}
					{`  (${props.count})`}
				</Text>
			</Flex>
			<Flex style={{padding: "4px 5px 0px 0px"}}>
				<Flex gap={GapSize.Large}>
					{props.additionalActions ? <>{...props.additionalActions}</> : <></>}
				</Flex>
				<SupervisorTypeFilter
					cacheKey={getCacheKeyByTableType()}
					type={type}
					filterData={filterData}
				/>
				<SupervisorQueueFilter
					cacheKey={getCacheKeyByTableType()}
					type={type}
					filterData={filterData}
				/>
			</Flex>
		</Flex>
	);
};
